export default {"src":"/_next/static/media/filter.0d636870.svg","height":10,"width":12,"blurWidth":0,"blurHeight":0};